/* tslint:disable */
/* eslint-disable */
/**
 * Business Orchestration layer (BOL) Notifications API
 * Business Orchestration layer (BOL) Notifications API.  This API is used to manage subscriptions and consumers for BOL notifications. 
 *
 * The version of the OpenAPI document: 7.2.1-develop.2
 * Contact: benoit.tiers@logist-x.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Batch configuration for the consumer.
 * @export
 * @interface ConsumerBatch
 */
export interface ConsumerBatch {
    /**
     * Maximum number of messages to send in a single batch.
     * @type {number}
     * @memberof ConsumerBatch
     */
    capacity?: number;
    /**
     * Minimum time interval between two batches in milliseconds.
     * @type {number}
     * @memberof ConsumerBatch
     */
    minInterval?: number;
}

/**
 * Check if a given object implements the ConsumerBatch interface.
 */
export function instanceOfConsumerBatch(value: object): value is ConsumerBatch {
    return true;
}

export function ConsumerBatchFromJSON(json: any): ConsumerBatch {
    return ConsumerBatchFromJSONTyped(json, false);
}

export function ConsumerBatchFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConsumerBatch {
    if (json == null) {
        return json;
    }
    return {
        
        'capacity': json['capacity'] == null ? undefined : json['capacity'],
        'minInterval': json['minInterval'] == null ? undefined : json['minInterval'],
    };
}

export function ConsumerBatchToJSON(json: any): ConsumerBatch {
    return ConsumerBatchToJSONTyped(json, false);
}

export function ConsumerBatchToJSONTyped(value?: ConsumerBatch | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'capacity': value['capacity'],
        'minInterval': value['minInterval'],
    };
}

